import { SplideSlide } from '@splidejs/react-splide'
import { useSearchParams } from 'react-router-dom'

export default function OpportunitiesCountriesSliderItems({ countries, lng }) {
  const [searchParams, setSearchParams] = useSearchParams()

  const handleOnClickCountry = (countryId) => {
    searchParams.set('COUNTRY', countryId)
    setSearchParams(searchParams)
  }

  if (!countries?.length) {
    return null
  }

  return countries.map((country) => (
    <SplideSlide
      key={country.id}
      className={`mt-2 cursor-pointer rounded-none`}
    >
      <div
        onClick={() => handleOnClickCountry(country.id)}
        className={`z-50 flex h-full transform flex-col items-center space-y-4 border-2 px-1 py-4 ${searchParams.get('COUNTRY') == country.id ? 'border-secondary-600 text-secondary-600 bg-light' : 'hover:border-secondary-600 hover:text-secondary-600 border-transparent hover:bg-light'} `}
      >
        <div>
          <img
            className="tv:h-[128px] border-muted-300 h-[64px] border-2"
            src={`${process.env.REACT_APP_API_BASE_URL}/storage/flags/${country.image}`}
            alt={`${country[`name_${lng}`]} flag`}
            aria-hidden={true}
          />
        </div>
        <h3 className="text-center font-semibold">{country[`name_${lng}`]}</h3>
      </div>
    </SplideSlide>
  ))
}
